// extracted by mini-css-extract-plugin
module.exports = {"container":"ResultsTeaser_container__Igrpi","grid":"ResultsTeaser_grid__Ix5ly","headlineNumber":"ResultsTeaser_headlineNumber__vZBBx"};